<template>
	<div style="height: calc(100vh - 56px); overflow-y: scroll;">
		<div class="mx-auto mt-4" style="max-width: 1320px;">
			<div>
				<CCol>
					<clientFilter v-if="isSysAdmin || isGroupAdmin" class="" />
				</CCol>
			</div>
			<div class="d-flex">
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 px-4 text-center font-weight-bolder m-auto">
							AP Spend
						</div>
						<div
							class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
							{{ spendData.total_spend }}
						</div>
					</div>
				</CCol>
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 px-4 text-center font-weight-bolder m-auto">
							PO Spend
						</div>
						<div
							class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
							{{ spendData.po_spend }}
						</div>
					</div>
				</CCol>
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 px-4 text-center font-weight-bolder m-auto">
							Total Opportunity
						</div>
						<div
							class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
							{{ dates.potential_savings }}
						</div>
					</div>
				</CCol>
			</div>
			<div>
				<CCol>
					<div class="d-flex justify-content-between">
						<div class="border bg-white d-flex flex-column" style="width: 55%;">
							<div class="p-2 text-center font-weight-bolder m-auto">High Level Spend</div>
							<div class="border-top p-4 py-3">

								<PieChart style="height: 280px; width: 100%;" :chart-data="highLevelSpendChartData"
									:isHalf="false" :key="1" @on-receive="pieChartOptionClickHandler">
								</PieChart>
							</div>
						</div>
						<div class="d-flex flex-column justify-content-center" style="gap:32px; width: 40%;">
							<div style="display: grid; gap: 16px; grid-template-columns: 1fr 1fr;">
								<div class="border bg-white d-flex flex-column" style="width: 100%;">
									<div class="p-2 px-4 text-center font-weight-bolder m-auto">
										% of AP Spend on PO
									</div>
									<div
										class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
										<GaugeChart style="height: 120px; width: 90%;"
											:chart-data="apSpendOnPOChartData" :isHalf="true" :key="1"
											:legendFontSize="14" />
										<div class="position-absolute" style="bottom: 16px;">{{
											apSpendOnPOChartData.label
										}}%
										</div>
									</div>
								</div>
								<div class="border bg-white d-flex flex-column" style="width: 100%;">
									<div class="p-2 px-4 text-center font-weight-bolder m-auto">
										% of PO Spend on Contract
									</div>
									<div
										class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
										<GaugeChart style="height: 120px; width: 90%;"
											:chart-data="contractSpendChartData" :isHalf="true" :key="1"
											:legendFontSize="14" />
										<div class="position-absolute" style="bottom: 16px;">{{
											contractSpendChartData.label
										}}%
										</div>
									</div>
								</div>
							</div>
							<div style="display: grid; gap: 16px; grid-template-columns: 1fr 1fr;">
								<div class="border bg-white d-flex flex-column" style="width: 100%;">
									<div class="p-2 px-4 text-center font-weight-bolder m-auto">
										% of Vendors with PO in Excess of AP Spend
									</div>
									<div
										class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
										<GaugeChart style="height: 120px; width: 90%;"
											:chart-data="poExcessApSpendChartData" :isHalf="true" :key="1"
											:legendFontSize="14" />
										<div class="position-absolute" style="bottom: 16px;">{{
											poExcessApSpendChartData.label
										}}%</div>
									</div>
								</div>
								<div class="border bg-white d-flex flex-column" style="width: 100%;">
									<div class="p-2 px-4 text-center font-weight-bolder m-auto">
										% of Spend Mapped for Opportunity Development
									</div>
									<div
										class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
										<GaugeChart style="height: 120px; width: 90%;"
											:chart-data="mappedOpportunityDevelopmentChartData" :isHalf="true" :key="1"
											:legendFontSize="14" />
										<div class="position-absolute" style="bottom: 16px;">
											<div>{{ mappedOpportunityDevelopmentChartData.label }}%</div>
											<div>{{ mappedOpportunityDevelopmentChartData.dollarVal }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</CCol>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "../Utility/utility";
import gql from "graphql-tag";
import clientFilter from "../../components/clientFilter";
import { storeData } from "../../store";
import { mapMutations } from 'vuex';
import PieChart from "../../components/charts/PieChart";
import GaugeChart from "../../components/charts/GaugeChart";
import { getSelectedClients } from "../../store";

export default {
	data() {
		return {
			AP_PO_SPEND_TABLE_COLUMNS: [{ key: "vendor_source" }, { key: "po" }, { key: "non_po" }, { key: "ap" }],
			CONTRACT_SPEND_TABLE_COLUMNS: [{ key: "vendor_name" }, { key: "ap_spend" }, { key: "po_spend" }],
			spinner: false,
			spendData: {},
			dates: {},
			highLevelSpendChartData: {},
			apSpendOnPOChartData: {
			},
			contractSpendChartData: {
			},
			poExcessApSpendChartData: {
			},
			mappedOpportunityDevelopmentChartData: {
			}
		};
	},
	components: {
		clientFilter,
		PieChart,
		GaugeChart
	},
	computed: {
		isSysAdmin() {
			return storeData.currentUserDetails.role.name === "sys_admin";
		},
		isGroupAdmin() {
			return storeData.currentUserDetails.role.name === "group_admin";
		},
		selectedClients() {
			return getSelectedClients();
		}
	},
	watch: {
		async selectedClients() {
			this.spinner = true;
			await this.fetchData();
			this.spinner = false;
		}
	},
	methods: {
		...mapMutations(['setStatusFilter']),
		...mapMutations(['setAp_PO_Date']),

		async fetchData() {
			await this.$apollo
				.mutate({
					mutation: GET_TOTAL_SPEND_AND_OPPORTUNITY,
					variables: {
						clients: this.selectedClients,
					},
				})
				.then((res) => {
					this.spendData = res.data.spendmd_db_total_spend_and_opportunity_aggregate.aggregate.sum;
					this.dates = { ...res.data.spendmd_db_total_spend_and_opportunity_aggregate.aggregate.max, ...res.data.spendmd_db_total_spend_and_opportunity_aggregate.aggregate.min };

					this.setAp_PO_Date({
						ap_start: this.dates.ap_start,
						ap_end: this.dates.ap_end,
						po_start: this.dates.po_start,
						po_end: this.dates.po_end,
						ap_note: this.dates.ap_note,
						po_note: this.dates.po_note,
					});
					this.highLevelSpendChartData = {
						labels: [
							`Supply Spend: ${this.spendData.supplies_spend}`,
							`Purchased Service Spend: ${this.spendData.services_spend}`,
							`TBD Spend: ${this.spendData.tbd_spend}`,
							`Out of Scope Spend: ${this.spendData.out_of_scope_spend}`,
						],
						datasets: [
							{
								backgroundColor: [this.$themeColors.green["300"], this.$themeColors.green["200"], this.$themeColors.green["100"], this.$themeColors.green["400"]],
								data: [
									_.parseAmountToNumber(this.spendData.supplies_spend),
									_.parseAmountToNumber(this.spendData.services_spend),
									_.parseAmountToNumber(this.spendData.tbd_spend),
									_.parseAmountToNumber(this.spendData.out_of_scope_spend),
								]
							}
						]
					};
				}).catch((err) => {
					console.log(err);
				});

			await this.$apollo
				.mutate({
					mutation: SPENDMD_DB_SUMMARY_DASHBOARD_GAUGES,
					variables: {
						clients: this.selectedClients,
					},
				})
				.then((res) => {
					const percentData = res.data.spendmd_db_summary_dashboard_gauges[0];

					if (!percentData) {
						return;
					}
					this.apSpendOnPOChartData = {
						labels: [
							``,
						],
						datasets: [
							{
								backgroundColor: [this.$themeColors.green["300"], this.$themeColors.green["200"]],
								data: [
									percentData.percent_ap_on_po * 100, (1 - percentData.percent_ap_on_po) * 100
								]
							}
						],
						label: (percentData.percent_ap_on_po * 100).toFixed(0),
					};
					this.contractSpendChartData = {
						labels: [
							``,
						],
						datasets: [
							{
								backgroundColor: [this.$themeColors.green["300"], this.$themeColors.green["200"]],
								data: [
									percentData.percent_on_contract * 100, (1 - percentData.percent_on_contract) * 100
								]
							}
						],
						label: (percentData.percent_on_contract * 100).toFixed(0),
					};
					this.poExcessApSpendChartData = {
						labels: [
							``,
						],
						datasets: [
							{
								backgroundColor: [this.$themeColors.green["300"], this.$themeColors.green["200"]],
								data: [
									percentData.percent_po_excess_ap * 100, (1 - percentData.percent_po_excess_ap) * 100
								]
							}
						],
						label: (percentData.percent_po_excess_ap * 100).toFixed(0),
					};
					this.mappedOpportunityDevelopmentChartData = {
						labels: [
							``,
						],
						datasets: [
							{
								backgroundColor: [this.$themeColors.green["300"], this.$themeColors.green["200"]],
								data: [
									percentData.percent_opp_developed * 100, (1 - percentData.percent_opp_developed) * 100
								]
							}
						],
						label: (percentData.percent_opp_developed * 100).toFixed(0),
						dollarVal: percentData.dollar_opp_developed,
					};
				}).catch((err) => {
					console.log(err);
				});
		},
		pieChartOptionClickHandler(data) {
			const index = data.index;
			let target;
			switch (index) {
				case 0:
					target = "SUPPLY_SPEND";
					break;
				case 1:
					target = "PURCHASE_SERVICE_SPEND";
					break;
				case 2:
					target = "TBD_SPEND";
					break;
				case 3:
					target = "OUT_OF_SCOPE_SPEND";
					break;
				default:
					target = "SUPPLY_SPEND";
					break;
			}
			this.goTo(target);
		},
		goTo(targetPage) {
			let newScope = 0;
			let selectedPrimaryCategories;

			switch (targetPage) {
				case "TOTAL_SPEND":
					newScope = 0;
					break;

				case "SUPPLY_SPEND":
					newScope = 1;
					selectedPrimaryCategories = [10];
					break;

				case "PURCHASE_SERVICE_SPEND":
					newScope = 1;
					selectedPrimaryCategories = [11];
					break;

				case "TBD_SPEND":
					newScope = 1;
					selectedPrimaryCategories = [12];
					break;

				case "OUT_OF_SCOPE_SPEND":
					newScope = 2;
					break;

				default:
					break;
			}

			this.setStatusFilter(newScope);
			if (selectedPrimaryCategories) {
				this.$store.commit("set", ["tempSelectedPrimaryCategories", selectedPrimaryCategories]);
			}
			this.$router.push("/spend-dashboard");
		}
	},
	async mounted() {
		this.spinner = true;
		await this.fetchData();
		this.spinner = false;
	}
};

const GET_TOTAL_SPEND_AND_OPPORTUNITY = gql`
	query (
		$clients: json
	) {
		spendmd_db_total_spend_and_opportunity_aggregate(
			args: {
				clients: $clients
			}
		) {
			aggregate {
				sum {
					total_spend
					supplies_spend
					services_spend
					tbd_spend
					out_of_scope_spend
					po_spend
				}
				min {
					ap_start
					po_start
					ap_note
					po_note
				}
				max {
					ap_end
					po_end
					potential_savings
					ap_note
					po_note
				}
			}
			nodes {
				client_id
			}
		}
	}
`;

const SPENDMD_DB_SUMMARY_DASHBOARD_GAUGES = gql`
	query (
		$clients: json
	) {
		spendmd_db_summary_dashboard_gauges(
			args: {
				clients: $clients
			}
		) {
			id
			percent_ap_on_po
			percent_on_contract
			percent_po_excess_ap
			percent_opp_developed
			dollar_opp_developed
		}
	}
`;
</script>

<style scoped>
/* Desktop */
@media screen and (min-width: 768px) {
	.v-dialog--custom {
		width: 50%;
	}
}
</style>
